import { render, staticRenderFns } from "./DetailsPopup.vue?vue&type=template&id=76670d44"
import script from "./DetailsPopup.vue?vue&type=script&lang=js"
export * from "./DetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports